import { useLocalStorageState } from "ahooks"

const UNSEEN_WINDOW_DAYS = 30
const DAY_MS = 24 * 60 * 60 * 1000

const isAfter = (iso: string, otherIso: string) => Date.parse(iso) > Date.parse(otherIso)

const useWhatsNewSeenAt = (userId: string) => {
  const [seenAt, setSeenAt] = useLocalStorageState<string>(
    `dio:whats_new_seen_at:${userId}`,
    { listenStorageChange: true },
  )

  const isUnseen = (publishedAt: string) => (
    seenAt
      ? isAfter(publishedAt, seenAt)
      : Date.now() - Date.parse(publishedAt) < UNSEEN_WINDOW_DAYS * DAY_MS
  )

  const markSeen = (publishedAt: string) => {
    if (!seenAt || isAfter(publishedAt, seenAt)) {
      setSeenAt(publishedAt)
    }
  }

  return { isUnseen, markSeen }
}

export default useWhatsNewSeenAt
